// Generic email providers that cannot enable workspace discovery
const BLOCKED_GENERIC_DOMAINS = [
	// Google
	'gmail.com',
	'googlemail.com',

	// Microsoft
	'outlook.com',
	'hotmail.com',
	'hotmail.co.uk',
	'hotmail.fr',
	'hotmail.de',
	'hotmail.it',
	'hotmail.es',
	'hotmail.co.jp',
	'hotmail.com.br',
	'live.com',
	'live.co.uk',
	'live.fr',
	'live.de',
	'live.it',
	'live.com.au',
	'msn.com',

	// Yahoo
	'yahoo.com',
	'yahoo.co.uk',
	'yahoo.co.in',
	'yahoo.co.jp',
	'yahoo.fr',
	'yahoo.de',
	'yahoo.com.br',
	'yahoo.com.au',
	'yahoo.ca',
	'yahoo.it',
	'yahoo.es',
	'yahoo.com.mx',
	'yahoo.com.ar',
	'yahoo.com.sg',
	'yahoo.com.hk',
	'ymail.com',
	'rocketmail.com',

	// Apple
	'icloud.com',
	'me.com',

	// Privacy-focused
	'protonmail.com',
	'proton.me',
	'pm.me',
	'tuta.com',
	'tutanota.com',
	'fastmail.com',
	'hushmail.com',
	'mailfence.com',
	'hey.com',
	'posteo.de',
	'runbox.com',
	'disroot.org',

	// Chinese providers
	'qq.com',
	'163.com',
	'126.com',
	'sina.com',
	'sina.cn',
	'sohu.com',
	'aliyun.com',

	// Korean providers
	'naver.com',
	'daum.net',
	'hanmail.net',

	// Russian providers
	'mail.ru',
	'yandex.com',
	'yandex.ru',
	'rambler.ru',
	'bk.ru',
	'inbox.ru',
	'list.ru',

	// German providers
	'web.de',
	'gmx.com',
	'gmx.de',
	'gmx.at',
	'gmx.ch',
	't-online.de',
	'freenet.de',

	// Italian providers
	'libero.it',
	'virgilio.it',
	'alice.it',
	'tin.it',

	// French providers
	'laposte.net',
	'free.fr',
	'orange.fr',
	'wanadoo.fr',
	'sfr.fr',

	// Brazilian providers
	'uol.com.br',
	'bol.com.br',
	'terra.com.br',

	// US ISP providers
	'aol.com',
	'att.net',
	'sbcglobal.net',
	'comcast.net',
	'verizon.net',
	'bellsouth.net',
	'cox.net',
	'charter.net',
	'spectrum.net',
	'earthlink.net',
	'juno.com',

	// Canadian ISP providers
	'rogers.com',
	'shaw.ca',
	'sympatico.ca',
	'telus.net',

	// UK ISP providers
	'btinternet.com',
	'sky.com',
	'ntlworld.com',
	'talktalk.net',
	'virginmedia.com',

	// Australian ISP providers
	'bigpond.com',
	'optusnet.com.au',

	// Other generic providers
	'zoho.com',
	'mail.com',
	'rediffmail.com',
	'inbox.com',

	// Disposable/temporary email providers
	'guerrillamail.com',
	'guerrillamail.de',
	'guerrillamail.net',
	'mailinator.com',
	'tempmail.com',
	'yopmail.com',
	'sharklasers.com',
	'grr.la',
	'temp-mail.org',
	'throwaway.email',
	'maildrop.cc',
	'dispostable.com',
] as const;

// TLD suffixes — match only at the end of the domain (e.g. harvard.edu, mit.edu)
const BLOCKED_TLD_SUFFIXES = ['.edu', '.university', '.school'];

// Mid-domain patterns — match anywhere in the domain (e.g. student.edu.au, ox.ac.uk, delhi.sch.in)
const BLOCKED_MID_DOMAIN_PATTERNS = ['.edu.', '.ac.', '.sch.'];

export function isBlockedDomain(domain: string): boolean {
	const lowerDomain = domain.toLowerCase();

	if (BLOCKED_GENERIC_DOMAINS.includes(lowerDomain as (typeof BLOCKED_GENERIC_DOMAINS)[number])) {
		return true;
	}

	if (BLOCKED_TLD_SUFFIXES.some((suffix) => lowerDomain.endsWith(suffix))) {
		return true;
	}

	return BLOCKED_MID_DOMAIN_PATTERNS.some((pattern) => lowerDomain.includes(pattern));
}

export function extractDomainFromEmail(email: string): string {
	return email.split('@')[1]?.toLowerCase() ?? '';
}
